import React, { FunctionComponent } from 'react';
import summaryStyles from '../summarySection/SummaryStyles';
import CarUnavailable from '../../../../../../common/assets/images/carUnavailable.png';
import FitImage from '../../../../../../common/components/image/FitImage';

export interface ISummaryImage {
  imageUrl: string;
}

const SummaryImage: FunctionComponent<ISummaryImage> = ({ imageUrl }) => {
  const styles = summaryStyles();

  return (
    <FitImage
      src={imageUrl}
      alt="car"
      className={styles.image}
      animationDuration={0}
      color="transparent"
      aspectRatio={2.05}
      errorIcon={
        <img
          src={CarUnavailable}
          className={styles.image}
          alt="Unavailable car image"
          data-test={'image:vehicle:unavailable'}
        />
      }
    />
  );
};

export default SummaryImage;
